import React from 'react';
import { Statistics } from '~/components/Statistics';
import { SearchView } from '~/components/Search';

export function Dashboard() {
    return (
        <div className="container">
            <Statistics />
            <div className="row justify-content-center">
                <div className="col-12 col-lg-10 col-xl-8">
                    <SearchView />
                </div>
            </div>
        </div>
    );
}
